import { BedIcons } from '@assets/images/beds';

export const getBedIcon = (type: string) => {
  switch (type) {
    case 'twins':
    case 'bunk':
      return BedIcons.twins;
    case 'couch':
    case 'sofa':
      return BedIcons.couch;
    case 'full':
    case 'double':
      return BedIcons.full_bed;
    case 'king':
      return BedIcons.king_bed;
    case 'queen':
      return BedIcons.queen_bed;
    case 'twin':
    case 'single':
    default:
      return BedIcons.twin;
  }
};
